import { Link } from "react-router-dom";
import { site } from "@/mocks/site-data";

export default function SubpageHeader() {
  return (
    <header className="border-b border-secondary-300 bg-background-50/95 backdrop-blur-md">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-3" aria-label="Voltar ao início">
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-accent-400/70">
            <img
              src="https://public.readdy.ai/ai/img_res/fe4adf6c-5bca-46d7-9c2e-e5888e9d0642.png"
              alt="Logo Dra. Sâmia Albuquerque"
              className="h-6 w-6 object-contain"
            />
          </span>
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-heading text-lg font-semibold text-foreground-50">
              Dra. Sâmia Albuquerque
            </span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-foreground-400">
              Médica · {site.crm}
            </span>
          </span>
        </Link>

        <a
          href={site.whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-400"
        >
          Agendar avaliação
        </a>
      </div>
    </header>
  );
}